<template>
  <div class="row middle-xs">
    <div class="col-xs-12 col-sm-6 mb-16">
      <Address :address="address" />
    </div>
    <template v-if="showAction">
      <div class="col-xs-12 col-sm-6">
        <div class="row middle-sm">
          <div class="col-xs-12 col-sm-6">
            <SfButton
              @click="$emit('changeAddress', address.Id)"
            >
              {{ $t('Change') }}
            </SfButton>
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfButton
              @click="$emit('removeAddress' , address.Id)"
            >
              {{ $t('Delete') }}
            </SfButton>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import {
  SfButton,
} from '@storefront-ui/vue';
import { config } from '@/modules/core';
import Address from './Address.vue';

export default {
  name: 'AddressItem',
  mixins: [config],
  components: {
    SfButton,
    Address,
  },
  props: {
    address: {
      type: Object,
      required: true,
    },
    showAction: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

@include flexbox-mobile {
  .sf-button {
    margin-bottom: var(--spacer-xs);
  }

  .mb-16 {
    margin-bottom: var(--spacer-sm);
  }
}

.sf-button {
  --button-width: 100%;
}

.mb-32 {
  margin-bottom: var(--spacer-lg);
}
</style>
